import { render, staticRenderFns } from "./SiteCardComponent.vue?vue&type=template&id=42fbd139&scoped=true"
import script from "./SiteCardComponent.vue?vue&type=script&lang=js"
export * from "./SiteCardComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fbd139",
  null
  
)

export default component.exports